import { createBlacklistItem as createBlacklistItemHttpRequest } from '../api';
import { deleteBlacklistItem as deleteBlacklistItemHttpRequest } from '../api';
import { fetchBlacklist as fetchBlacklistHttpRequest } from '../api';

export const REQUEST_BLACKLIST = 'REQUEST_BLACKLIST';
export const RECEIVE_BLACKLIST = 'RECEIVE_BLACKLIST';
export const RECEIVE_BLACKLIST_ERROR = 'RECEIVE_BLACKLIST_ERROR';
export const REQUEST_SAVE_BLACKLIST = 'REQUEST_SAVE_BLACKLIST';
export const RECEIVE_SAVE_BLACKLIST = 'RECEIVE_SAVE_BLACKLIST';
export const RECEIVE_SAVE_BLACKLIST_ERROR = 'RECEIVE_SAVE_BLACKLIST_ERROR';

function requestBlacklist() {
    return {
        type: REQUEST_BLACKLIST,
    };
}

function receiveBlacklist(blacklist) {
    return {
        type: RECEIVE_BLACKLIST,
        blacklist,
        receivedAt: Date.now(),
    };
}

function receiveBlacklistError(error) {
    return {
        type: RECEIVE_BLACKLIST_ERROR,
        error,
    };
}

function requestSaveBlacklist() {
    return {
        type: REQUEST_SAVE_BLACKLIST,
    };
}

function receiveSaveBlacklist() {
    return {
        type: RECEIVE_SAVE_BLACKLIST,
        receivedAt: Date.now(),
    };
}

function receiveSaveBlacklistError(data, error) {
    return {
        type: RECEIVE_SAVE_BLACKLIST_ERROR,
        error,
    };
}

export function fetchBlacklist() {
    return (dispatch, getState) => {
        dispatch(requestBlacklist());
        const user = getState().user;
        return fetchBlacklistHttpRequest(user.group.Id)
            .then(blacklist => dispatch(receiveBlacklist(blacklist)))
            .catch(error => dispatch(receiveBlacklistError(error)));
    };
}

export function createBlacklistItem(customerId, deviceCode, paymentMethod, orderId) {
    return (dispatch, getState) => {
        dispatch(requestSaveBlacklist());
        const user = getState().user;

        return createBlacklistItemHttpRequest(user.group.Id, customerId, deviceCode, paymentMethod, orderId)
            .then(() => dispatch(receiveSaveBlacklist()))
            .catch(error => dispatch(receiveBlacklistError(error)));
    };
}

export function deleteBlacklistItem(blacklistItemId) {
    return (dispatch, getState) => {
        dispatch(requestSaveBlacklist());
        const user = getState().user;

        return deleteBlacklistItemHttpRequest(user.group.Id, blacklistItemId)
            .then(() => dispatch(receiveSaveBlacklist()))
            .catch(error => dispatch(receiveSaveBlacklistError(error)));
    };
}
